export const DOCUMENT_UPLOAD_FRAGMENT = `
  id
  logID
  fileName
  fileSize
  url
  uploadType
  mimeType
  isDeleted
  createdAt
`;

export const CREATE_DOCUMENT_UPLOAD_MUTATION_QUERY = `
  mutation CreateUserDocumentUpload($input: CreateUserDocumentUploadInput!) {
    createUserDocumentUpload(input: $input) {
      userDocumentUploadEdge {
        node {
          ${DOCUMENT_UPLOAD_FRAGMENT}
        }
      }
    }
  }
`;
